import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { FormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

export interface SlaValues  {
  critical: number | null;
  high: number | null;
}

@Component({
  selector: 'app-sla-dialog',
  templateUrl: './sla-dialog.component.html',
  styleUrls: ['./sla-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, FormsModule, DialogsModule, ButtonsModule],
})
export class SlaDialogComponent {
  isVisible = input.required<boolean>();
  slaValues = input.required<SlaValues>();

  onSave = output<SlaValues>();
  onCancel = output<void>();

  updateCritical(value: number): void {
    this.slaValues().critical = value;
  }

  updateHigh(value: number): void {
    this.slaValues().high = value;
  }
}
